import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { NavigationService } from 'src/app/core/navigation.service';
import { UtilsService } from 'src/app/core/utils.service';
import { OrderDetailsNavbarComponent } from '../order-details-navbar/order-details-navbar.component';
import { Order, OrdersService, OrderStatus } from 'src/app/core/orders.service';
import { ErrorService, SplittypayError } from 'src/app/core/error.service';
import { DialogService } from 'src/app/core/dialog.service';
import { OrdersQineticReloadDialogComponent } from 'src/app/orders/orders-qinetic-reload-dialog/orders-qinetic-reload-dialog.component';

@Component({
  selector: 'app-order-details-header',
  templateUrl: './order-details-header.component.html',
  styleUrls: ['./order-details-header.component.scss'],
})
export class OrderDetailsHeaderComponent {
  @Input() order_id?: string | null;
  @Input() store_id?: string | null;

  @Output() refresh: EventEmitter<void> = new EventEmitter<void>();
  @Output() tab_change: EventEmitter<string> = new EventEmitter<string>();

  order?: Order;
  is_read_running = false;

  constructor(
    private utils_service: UtilsService,
    private navigation_service: NavigationService,
    private orders_service: OrdersService,
    private error_service: ErrorService,
    private dialog_service: DialogService,
  ) {}

  ngOnInit(): void {
    this.readOrder(this.store_id as string, this.order_id as string);
  }

  onBackClick(): void {
    this.navigation_service.toOrders();
  }

  readOrder(store_id: string, order_id: string): void {
    this.is_read_running = true;
    this.orders_service.read(store_id, order_id).subscribe({
      next: response => {
        this.order = response.data;
        this.is_read_running = false;
      },
      error: error => {
        this.error_service.processGenericApiError(error);
        this.is_read_running = false;
      },
    });
  }

  getShrinkedID(): string {
    return this.utils_service.getShrinkedID(this.order_id || '-');
  }

  isQineticReloadDisabled(): boolean {
    return (
      ![OrderStatus.refunded, OrderStatus.running, OrderStatus.canceled].includes(this.order?.status as OrderStatus) ||
      this.order?.position_id != undefined
    );
  }

  onQineticReloadClick(): void {
    this.dialog_service
      .openDialog(OrdersQineticReloadDialogComponent, { order: this.order })
      ?.afterClosed()
      .subscribe(dialog_result => {
        if (dialog_result && dialog_result.success) {
          this.refresh.emit();
        }

        if (dialog_result && dialog_result.error) {
          const processed_error: SplittypayError = dialog_result.error;
          this.error_service.processApiError(processed_error.code, processed_error.message);
        }
      });
  }
}
